module.exports = __webpack_public_path__ + "img/Facilidade_na_renovacao.b175b5d.svg";